<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-26 10:49:28
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-24 16:10:39
 * @FilePath: /chaoyongtuan/src/views/shopManage/commercialHigh/components/myPromonteGoods/tableCells/goodsMechanism.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <div class="mechanism-text font-h6-regular">服务费率：{{ row.serviceFeeRate }}%</div>
        <div class="mechanism-text font-h6-regular">达人佣金率：{{ row.talentCommission }}%</div>
    </div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default{
    mixins: [mixin],
    data(){
        return{}
    },
}
</script>
<style lang="less" scoped>
.mechanism-text{
    color: @color-gy9;
}
</style>